import React, { useState } from 'react';
import './Liviniti.css';

const Liviniti = () => {
    // Mock FAQ Data (Replace with actual FAQs later)
    const faqs = [
        { question: "What services do you offer?", answer: "We provide a wide range of services including custom consulting, support, and product solutions tailored to your business needs." },
        { question: "How can I contact support?", answer: "You can contact our support team via email at support@toptierbenefits.com" },
        { question: "What are your operating hours?", answer: "Our business operates Monday to Friday, from 8 AM to 6 PM CST." },
    ];

    // Expand/collapse FAQ answers
    const [openIndex, setOpenIndex] = useState(null);

    const toggleFAQ = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    return (
        <div className="liviniti-container">
            <h1 className="liviniti-title">Liviniti</h1>

            {/* Link Box */}
            <a href="https://ca.docusign.net/Member/PowerFormSigning.aspx?PowerFormId=b706938c-fc7f-4596-8170-6bc7ee9a0e9e&env=ca&acct=e6b74557-3473-4b9f-856e-4ebef6b2b3c7&v=2" target="_blank" rel="noopener noreferrer" className="liviniti-box">
                <div className="liviniti-content">
                    <h2>PATIENT ENROLLMENT FORM</h2>
                </div>
            </a>

            {/* FAQ Section */}
            <div className="liviniti-faq-section">
                <h2 className="liviniti-faq-title">Frequently Asked Questions</h2>
                <div className="liviniti-faq-list">
                    {faqs.map((faq, index) => (
                    <div
                        key={index}
                        className={`liviniti-faq-item ${openIndex === index ? "active" : ""}`}
                        onClick={() => toggleFAQ(index)}
                    >
                        <div className="liviniti-faq-question">
                        <strong>{faq.question}</strong>
                        <span className="liviniti-faq-icon">{openIndex === index ? "-" : "+"}</span>
                        </div>
                        <div className={`liviniti-faq-answer ${openIndex === index ? "show" : ""}`}>
                        {faq.answer}
                        </div>
                    </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Liviniti;